import { html, View } from 'rune-ts';
import {
  ProductFilterButton,
  ProductFilterButtonClickEvent,
  ProductFilterButtonData,
} from './ProductFilterButton';

export class ProductFilterButtonList extends View<ProductFilterButtonData[]> {
  selected: Set<number | string>;

  constructor(
    data: ProductFilterButtonData[],
    selected: (number | string)[],
    private option: {
      // container klass
      klass?: string;

      // filter btn klass
      btn_klass?: string;
    },
  ) {
    super(data, option);
    this.selected = new Set(selected);
  }

  override template() {
    return html`
      <div class="${this.option.klass}">
        ${this.data.map(
          ({ id, name }) =>
            new ProductFilterButton(
              { id, name },
              { is_active: this.selected.has(id), klass: this.option.btn_klass },
            ),
        )}
      </div>
    `;
  }

  override onRender() {
    this.delegate(ProductFilterButtonClickEvent, ProductFilterButton, (e) => {
      const { id, is_active } = e.detail;
      if (is_active) {
        this.selected.add(id);
      } else {
        this.selected.delete(id);
      }
    });
  }

  clear() {
    this.selected.clear();
  }

  setSelected(selected: (number | string)[]) {
    this.selected = new Set(selected);
  }
}
